import script from "./HomeIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeIndex.vue?vue&type=script&setup=true&lang=js"

import "./HomeIndex.vue?vue&type=style&index=0&id=199310cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199310cc"]])

export default __exports__